module.exports = __webpack_public_path__ + "media/images/marker-icon-2x-401d815dc206b8dc1b17cd0e37695975.png";